import { Modal } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { GrossCodeOption } from "../grossing/GrossTemplateSelector";
import SpecimenEditForm from "./SpecimenEditForm";

interface SourceOption {
  value: string;
  label: string;
  defaultCollectionMethodId?: string;
  defaultCollectionMethodName?: string;
}

interface SpecimenEditModalProps {
  opened: boolean;
  onClose: () => void;
  index: number | null;
  specimen: any | null;
  form: UseFormReturnType<any>;
  onCertaintyChange?: (field: string, certainty: number) => void;
  sources: SourceOption[];
  subsites: Record<string, Array<{ value: string; label: string }>>;
  collectionMethods: Array<{ value: string; label: string }>;
  grossCodes: GrossCodeOption[];
  isConsultation?: boolean;
  assignedPrefix?: string;
  getSourceName: (sourceId: string | null | undefined) => string | undefined;
  getSubsiteName: (
    sourceId: string | null | undefined,
    subsiteId: string | null | undefined
  ) => string | undefined;
}

export default function SpecimenEditModal({
  opened,
  onClose,
  index,
  specimen,
  form,
  onCertaintyChange,
  sources,
  subsites,
  collectionMethods,
  grossCodes,
  isConsultation,
  assignedPrefix,
  getSourceName,
  getSubsiteName,
}: SpecimenEditModalProps) {
  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      size="900px"
      centered
      closeOnClickOutside={false}
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title fw={600}>
            Edit Specimen {specimen?.number ?? ""}
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        {opened && specimen && index !== null ? (
          <SpecimenEditForm
            key={index}
            index={index}
            specimen={specimen}
            form={form}
            onCertaintyChange={onCertaintyChange}
            sources={sources}
            subsites={subsites}
            collectionMethods={collectionMethods}
            grossCodes={grossCodes}
            isConsultation={isConsultation}
            assignedPrefix={assignedPrefix}
            getSourceName={getSourceName}
            getSubsiteName={getSubsiteName}
            onClose={onClose}
          />
        ) : null}
      </Modal.Content>
    </Modal.Root>
  );
}
